import i18next from "i18next";
import get from "lodash/get";
import { getResponseManager } from "../responseManager/BeeResponseManager";
export var getIntegrationName = function (state) {
    return get(state, "appReducer.integrationName");
};
export var getInitialData = function (state) {
    return get(state, "responseReducer.getInitialData.response");
};
export var getOptions = function (state) {
    var initialData = getInitialData(state);
    return initialData ? getResponseManager(initialData).options() : null;
};
export var getAdminBookingSettings = function (state) {
    var initialData = getInitialData(state);
    return initialData ? getResponseManager(initialData).adminBookingSettings() : null;
};
export var getFallbackMessage = function (state) {
    var options = getOptions(state);
    var email = get(options, "receiver_email", "");
    var phone = get(options, "phone", "");
    return i18next.t("fallback_error_message", {
        email: email && "<a href=\"mailto:" + email + "\">" + email + "</a>",
        phone: phone
    });
};
export var getAppContext = function (state) {
    return get(state, "appContext");
};
export var getIntegrationURL = function (state) {
    var _a;
    var apiIntegrationAddress = get(getAppContext(state), "apiIntegrationAddress");
    try {
        apiIntegrationAddress = apiIntegrationAddress || ((_a = getResponseManager(getInitialData(state)).options()) === null || _a === void 0 ? void 0 : _a.api_integration_address);
        apiIntegrationAddress = apiIntegrationAddress.endsWith("#") ? apiIntegrationAddress : apiIntegrationAddress + "#";
    }
    catch (_b) {
    }
    return apiIntegrationAddress;
};
